module.exports = __webpack_public_path__ + "img/13.46206a42.png";